import type { CartConfig } from '#types/config/components/cart'
import type { RecursivePartial } from '#types/utils'

export default {
  orderSummary: {
    header: 'text-md fw-bold',
    subtotal: 'text-sm',
    total: 'uppercase text-sm fw-bold'
  },
} satisfies RecursivePartial<CartConfig['orderSummary']>
